import { jsx as _jsx } from "react/jsx-runtime";
import { ContentNoMemo } from "./content";
import { EditorContext } from "./editor";
export function Preview(props) {
    const { content, EditorModel } = props;
    const model = new EditorModel();
    model.performChange((ctx) => {
        ctx.load(content);
    });
    return (_jsx(EditorContext.Provider, Object.assign({ value: model }, { children: _jsx(ContentNoMemo, { items: content.items, length: content.length, baseOffset: 0, markers: [], previewOnly: true }, void 0) }), void 0));
}
